import { OmyConst } from "../OmyConst";
import Omy from "../Omy";
import OMath from "../utils/OMath";

import { Keyboard } from "../../lib/pixi.js-keyboard/index";

export default class KeyManager {
    constructor() {
        Keyboard.keyboard.events.on("down", null, this._onKeyDown.bind(this));
        Keyboard.keyboard.events.on("released", null, this._onReleased.bind(this));
        Keyboard.keyboard.events.on("pressed", null, this._onPressed.bind(this));

        /**
         * @type {Array}
         */
        this._keys = [];
        this._keysEmit = new OmyConst.Emit();
        this._downDuration = [];
        this._ANY_KEY = "any_key";
        this._blockBrowserHotKeys = false;

        this.blockBrowserHotKeys = true;
    }

    /** @public */
    update(delta) {
        Keyboard.keyboard.update();
    }

    clear() {
        Keyboard.keyboard.clear();
    }

    get blockBrowserHotKeys() {
        return this._blockBrowserHotKeys;
    }

    set blockBrowserHotKeys(value) {
        if (this._blockBrowserHotKeys === value) {
            return;
        }
        this._blockBrowserHotKeys = value;

        if (this._blockBrowserHotKeys) {
            window.addEventListener("keydown", this._onBrowserHotKey, false);
        } else {
            window.removeEventListener("keydown", this._onBrowserHotKey, false);
        }
    }

    _onBrowserHotKey(e) {
        let keyCode;
        const charCodeArr = {
            " ": 32,
            "Spacebar": 32,
            "ArrowLeft": 37,
            "ArrowUp": 38,
            "ArrowRight": 39,
            "ArrowDown": 40
        };
        if (e.key !== undefined) {
            keyCode = charCodeArr[e.key] || e.key.charCodeAt(0);
        } else {
            keyCode = e.which || e.charCode || e.keyCode || 0;
        }
        // space and arrow keys
        const blockKeys = [32, 37, 38, 39, 40];
        if (blockKeys.indexOf(keyCode) > -1) {
            e.preventDefault();
        }
    }

    _onKeyDown(key) {
        this._downDuration[key]++;
    }

    _onPressed(key) {
        this._downDuration[key] = 0;
        if (OMath.inArray(this._keys, String(key))) {
            this._keysEmit.emit(String(key));
        }
        this._keysEmit.emit(this._ANY_KEY);
    }

    _onReleased(key) {
        this._downDuration[key] = 0;
    }

    downDuration(key, durationSec) {
        return Boolean(this._downDuration[key] && (this._downDuration[key] / Omy.fps) >= durationSec);
    }

    isDown(key) {
        return Keyboard.keyboard.isKeyDown(key);
    }

    isPressed(key) {
        return Keyboard.keyboard.isKeyPressed(key);
    }

    isReleased(key) {
        return Keyboard.keyboard.isKeyReleased(key);
    }

    /**
     * @param {Number}key
     * @param {Function}func
     * @param {*}context
     * @param {Boolean}isEditorKey
     */
    registerFunction(key, func, context) {
        let keyName = String(key);
        if (!OMath.inArray(this._keys, keyName)) {
            this._keys.push(keyName);
        }
        let list = this._keysEmit._events;
        for (let listKey in list) {
            if (listKey === keyName && list[listKey].fn === func && list[listKey].context === context) {
                return;
            }
        }
        this._keysEmit.on(keyName, func, context);
    }

    /**
     * @param {Number}key
     * @param {Function}func
     * @param {*}context
     */
    unregisterFunction(key, func, context) {
        let keyName = String(key);
        if (OMath.inArray(this._keys, keyName)) {
            this._keysEmit.removeListener(keyName, func, context);
        }
    }

    /**
     * @param {Number}key
     */
    unregisterAllFunction(key) {
        let keyName = String(key);
        if (OMath.inArray(this._keys, keyName)) {
            this._keysEmit.removeAllListeners(keyName);
        }
    }

    addAnyKey(onHandler, context) {
        this._keysEmit.once(this._ANY_KEY, onHandler, context);
    }

    removeAnyKey(onHandler, context) {
        this._keysEmit.removeListener(this._ANY_KEY, onHandler, context);
    }
}
